import { createConsumer } from "@rails/actioncable";

// Shared, same-origin Action Cable consumer. createConsumer() defaults to the
// /cable mount (or the action_cable_meta_tag URL when present in <head>).
const consumer = createConsumer();

export default consumer;
